export default __webpack_public_path__ + "static/media/cocoa.0358fedc.png";